import i18n from 'localization';

export const errorCodeTypes = {
  personNotFoundError: {
    code: 'P01',
    name: 'PersonNotFoundError',
    message: i18n.t('shared.people.errors.notFound'),
  },
};
